import Pokedex from "./components/Pokedex";
import {Route, HashRouter} from "react-router-dom";
import {Helmet, HelmetProvider} from "react-helmet-async";

function App() {
  return (
    <HashRouter>
      <HelmetProvider>
        <Helmet>
          <title>Pokedex</title>
        </Helmet>
        <div className="App">
            <Route path="/">
              <Pokedex />
            </Route>
        </div>
      </HelmetProvider>
    </HashRouter>
  );
}

export default App;
